import { environment } from '../../environments/environment';

class ApiUrl {
  static paths = {
    searchTransaction: 'SearchTransaction',
    newLinkOperation: 'newlinkoperation',
    signPdf: 'sign-pdf',
    api: 'api',
    getScoring: 'get-scoring',
    closeOperation: 'close-op',
  };
}

export class UrlFactory {
  private static apiUrl: string = environment.API_URL;

  static postNewLinkOperation(): string {
    return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.newLinkOperation}/`;
  }

  static postSearchTransaction(): string {
    return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.searchTransaction}/`;
  }

  static postSignContract(): string {
    return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.signPdf}/`;
  }

  static getCreditScore(): string {
    return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.getScoring}/`;
  }

  static closeOperation(): string {
    return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.closeOperation}/`;
  }
}
